import React, { useState, useCallback, memo, useRef, useEffect } from "react";
import {
	GoogleMap,
	useLoadScript,
	Marker,
	OverlayView,
} from "@react-google-maps/api";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Polyline } from "@react-google-maps/api";
import icPoleLamp0 from "../../assets/images/ico-pole-lamp0.png";
import icPoleLamp1 from "../../assets/images/ico-pole-lamp1.png";
import icPoleLamp2 from "../../assets/images/ico-pole-lamp2.png";
import icPoleLamp3 from "../../assets/images/ico-pole-lamp3.png";
import icPoleLamp4 from "../../assets/images/ico-pole-lamp4.png";
import icPoleLamp0Off from "../../assets/images/ico-pole-lamp0-off.png"
import icPoleLamp1Off from "../../assets/images/ico-pole-lamp1-off.png";
import icPoleLamp2Off from "../../assets/images/ico-pole-lamp2-off.png";
import icPoleLamp3Off from "../../assets/images/ico-pole-lamp3-off.png";
import icPoleLamp4Off from "../../assets/images/ico-pole-lamp-off.png";
import icPoleLamp0On from "../../assets/images/ico-pole-lamp0-on.png";
import icPoleLamp1On from "../../assets/images/ico-pole-lamp1-on.png";
import icPoleLamp2On from "../../assets/images/ico-pole-lamp2-on.png";
import icPoleLamp3On from "../../assets/images/ico-pole-lamp3-on.png";
import icPoleLamp4On from "../../assets/images/ico-pole-lamp4-on.png";
import DeviceDataService from "../../apis/device-data";
import LampDataService from "../../apis/lamps-data";
import PoleDataService from "../../apis/pole-data";
import { getLampBySlcId, getSLCByPid, getSLCByid } from "../../query/device.query";
import "../../styles/dashboard.scss";
import { getCheckSession } from "../../apis/auth";
import { getSLCLine } from "../../query/slc-line.query";
import { Button, Grid } from "@material-ui/core";
import { getPoleBySlcId } from "../../query/pole.query";
import ReactToPrint from 'react-to-print';
 


const containerStyle = {
	 
	display: "flex",
	flexDirection: "column",
	height: "",
	width: "100%",
	 

};

const getCityName = () => {
	let configResponse = localStorage.getItem("firebaseConfigApiResponse");
	let detail = "";
	if (configResponse) {
		configResponse = JSON.parse(configResponse);
		detail = configResponse?.displayName;
		 
	}
	return detail.toUpperCase();
};


const GOOGLE_MAP_CONFIG = {
	//   apiKey: "AIzaSyAuCpOhLsnn5cLRvW3il_f_2Tb6mJ03eEU",
	// apiKey: "AIzaSyAn4guV9udrnZ0WVfxXWEr4ClB16ho2E",
	// apiKey: "AIzaSyA3YwoIVmgjMg0bCROj-ICuDiysP3r3XqE",
	apiKey: "AIzaSyAgpuvCWt4jbFoC7zjgl7MgwZBOg4zafUU",
	center: {
		lat: 10.95069,
		lng: 76.95634,
	},
	zoom: 15,
};

const DashGoogleMap = ({ data = [] }) => {

	const history = useHistory();

	const { isLoaded } = useLoadScript({
		id: "google-map-script",
		googleMapsApiKey: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${GOOGLE_MAP_CONFIG.apiKey}`,
	});

	const mapRef = React.useRef();
	const [map, setMap] = useState();
	const [marker, setMarker] = useState("");
	const [activePoles, setActivePoles] = useState([]);
	const [slcData, setSlcData] = useState([]);
	const [lampData, setLampData] = useState([]);
	const [activeMarker, setActiveMarker] = useState([]);
	const [slcLine, setslcLine] = useState({});
	const moveLampFlag = useRef(false);


	const [panelsStreetlightsInfoState, setPanelsStreetlightsInfoState] = useState({
		...DeviceDataService.getInstance().getCounts()
	  });
	  const [dashboardReportRawData, setDashboardReportRawData] = useState([]);
	  const [dashboardErrorReportData, setDashboardErrorReportData] = useState([]);
	///slc  propertices

	const [switchNo, setSwitchNo] = useState("");
	const [wardNo, setWardNo] = useState("");
	const [zoneNo, setZoneNo] = useState("");
	const [address, setAddress] = useState("");
	const [phase, setPhase] = useState("");
	const [slcUid, setSlcUid] = useState("");
	const [kiloWatts, setKilloWatts] = useState(0);
	const [location, setLocation] = useState("")
	const [uniqueLed, setUniqueLed] = useState([])
	const [uniqueLedCount, setUniqueLedCount] = useState([])

	const [dummyPoles, setDummyPoles] = useState(0);
	 
	const poleMarkerPosition = useRef({});
	const componentRef = useRef();

	const [dpi, setDPI] = useState(null);
	const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
	const [containerStyle, setContainerStyle] = useState({ 	display: "flex",flexDirection: "column",height: "800px",width: "100%", });

	///First Render
	useEffect(async () => {
		
		var sessionStatus = await getCheckSession();
		if (sessionStatus === false) {
			history.push("/");
			return;
		}
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const slcId = urlParams.get('data');
		setMarker(slcId);
		/// get auth session

		await PoleDataService.initService();

		// getPolesBySLC
		if(slcId != null || slcId.length>0){
		PoleDataService.getInstance().getPolesBySLC(slcId);
		}

		 
		var poleData = await  getPoleBySlcId(slcId).catch((e) => {
			 
		});
		 
		if (poleData != null) {
		
			 setActivePoles(poleData);
		}
		setActiveMarker(slcId)

		setslcLine(await getSLCLine(slcId));
		var slc = await getSLCByid(slcId).catch((e) => {
			console.log(e);
		});
		if (slc != null) {
			setSlcData(slc);
		}

		var LampData = await getLampBySlcId(slcId).catch((e) => {
			console.log(e);
		});
		if (LampData != null) {
			setLampData(LampData);
 		}
		LampDataService.initService(onFetchLampComplete,  null/*, onUpdateLampHandler*/);

		
		  
		
	}, []);

     const calculateDPI = () => {
      const div = document.createElement("div");
      div.style.width = "1in"; // 1 inch
      div.style.height = "1in";
      div.style.position = "absolute";
      div.style.left = "-100%"; // position off-screen
      document.body.appendChild(div);

      const dpiValue = div.offsetWidth; // width in pixels
      document.body.removeChild(div);
      
      return dpiValue;
    };
	/// Pole data and map update
 
	useEffect(()=>{
		if(activePoles.length > 0&& map)
			{
				updateMapBoundsByPoles(map, activePoles);

			}
	},[activePoles,map]);

 
	/// slc data update
 
	useEffect(() => {
 	 	setSwitchNo(slcData['sw_no']);
		setWardNo(slcData['wd']);
		setZoneNo(slcData['zn']);
		setAddress(slcData['addr']);
		setPhase(slcData['ph_cnt']);
		setSlcUid(slcData['dev_id']);
		setKilloWatts(slcData['kw'])
 
	}, [slcData]);

	/// lamp data update
	useEffect(() => {
		const uniqueWts = [...new Set(lampData.map(item => item.wt))];
		const wtCounts = uniqueWts.reduce((acc, wt) => {
 			acc[wt] = lampData.filter(item => item.wt === wt).length;
 			return acc;
		}, {});
		
		const dummyPoles = activePoles.filter(item => item.dmy === true);
 		setDummyPoles(dummyPoles.length);
		setUniqueLed(uniqueWts)
		setUniqueLedCount(wtCounts)
		
	 
	}, [lampData]);

	useEffect(()=>
		{
			activePoles.map((pol)=>{
				if(pol['is_slc'] == true){
					let degreeSymbol = "\u00B0";
					const {latitude:latitude,longitude:longitude} = pol['loc'];
					var result = "";
					if (latitude > 0) {
						result = `${latitude.toFixed(4)}${degreeSymbol}N`;
					  } else {
						result = `${latitude.toFixed(4)}${degreeSymbol}S`;
					  }
					  if (longitude > 0) {
						result = `[${result}, ${longitude.toFixed(4)}${degreeSymbol}E]`;
					  } else {
						result = `[${result}, ${longitude.toFixed(4)}${degreeSymbol}W]`;
					  }
					setLocation(`${result}`)
					 
				}
			})
			 
	},[activePoles])

	const onLoad = useCallback(async function callback(mapArg)
	 {	
		setMap(mapArg);
		const dpiValue = calculateDPI();

		setDPI(dpiValue);

		// A4 dimensions in inches
		const a4WidthInches = 8.27;
		const a4HeightInches = 11.69;

		// Calculate dimensions in pixels
		setDimensions({ width: dpiValue * a4WidthInches,height: dpiValue * a4HeightInches,});
		var mapHight = (dpiValue * a4HeightInches)*0.6;
		setContainerStyle ({display: "flex",flexDirection: "column",height:mapHight ,width: "100%", }); //set map size 
	
		
	}, 
		[]);
 
	const updateMapBoundsByPoles = (googleMap, poles) => {
		console.log("-->>updateMapBoundsByPoles");
		const bounds = new window.google.maps.LatLngBounds();

		poles.forEach((pole) => {
			let lat = 0;
			let lng = 0;

			if (pole != null && pole.loc != undefined && pole.loc != null) {
				const {
					loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
				} = pole;
				lat = latitudeVal;
				lng = longitudeVal;
			}
			const position = {
				lat,
				lng,
			};
			if (lat == 0 && lng == 0) {
				return;
			}
			return bounds.extend(position);
		});


		googleMap.fitBounds(bounds);
	}

	async function onFetchLampComplete() {
		updateDateSource(null, null, getDeviceSummary());
	  }
	
	  async function updateDateSource(deviceList, errorDeviceList, deviceSummary)  {
		if (deviceSummary != null) {
		  //Update device summary
		  setPanelsStreetlightsInfoState({...deviceSummary});
		}
		
		if (deviceList !== null) {
		  //Update device info for Map
		  setDashboardReportRawData(deviceList);
		}
	
		if (errorDeviceList != null) {
		//Update device info for Error table
		  setDashboardErrorReportData(errorDeviceList);
		}
	  }
	
	  function getDeviceSummary() {
		var result = null;
		var slcCountObj = DeviceDataService.getInstance().getCounts();
		if (slcCountObj != null) {
		  result = slcCountObj;
		}
		var lmpCountObj = LampDataService.getInstance().getCounts();
		if (lmpCountObj != null) {
		  if (result == null) {
			result = lmpCountObj;
		  } else {
			result.lmpCnt = lmpCountObj.lmpCnt;
			result.lmpOnCnt = lmpCountObj.lmpOnCnt;
			result.lmpOffCnt = lmpCountObj.lmpOffCnt;
			result.lmpErrCnt = lmpCountObj.lmpErrCnt;
		  }
		}
		return result;
	
	  }
 
	const getPoleImage = (pole) => {
		// debugger;
		var poleImage = icPoleLamp1;
		const { slc_id: slc_id, nfix: nfix = 0, is_slc: is_slc = false, dmy: dmy = false } = pole || {};
		if (is_slc) {
			var status = DeviceDataService.getInstance().isDeviceIdOn(slc_id);
			if (status == true) {
				/// SLC is on
				if (nfix === 0) {
					poleImage = icPoleLamp0On;///Green pole no lamp
				} else if (nfix === 1) {
					poleImage = icPoleLamp1On;///Green pole 1 lamp
				} else if (nfix === 2) {
					poleImage = icPoleLamp2On;///Green pole 2 lamp
				} else if (nfix === 3) {
					poleImage = icPoleLamp3On;///Green pole 3 lamp
				} else if (nfix > 3) {
					poleImage = icPoleLamp4On;///Green pole 4 lamp
				}
			} else {
				/// SLC is off
				if (nfix === 0) {
					poleImage = icPoleLamp0Off;///Red pole no lamp
				} else if (nfix === 1) {
					poleImage = icPoleLamp1Off;///Red pole 1 lamp
				} else if (nfix === 2) {
					poleImage = icPoleLamp2Off;///Red pole 2 lamp
				} else if (nfix === 3) {
					poleImage = icPoleLamp3Off;///Red pole 3 lamp
				} else if (nfix > 3) {
					poleImage = icPoleLamp4Off;///Red pole 4 lamp
				}
			}
		} else {
			if (nfix === 0) {
				poleImage = icPoleLamp0;///pole no lamp
			} else if (nfix === 1) {
				poleImage = icPoleLamp1;///pole 1 lamp
			} else if (nfix === 2) {
				poleImage = icPoleLamp2;///pole 2 lamp
			} else if (nfix === 3) {
				poleImage = icPoleLamp3;///pole 3 lamp
			} else if (nfix > 3) {
				poleImage = icPoleLamp4;///pole 4 lamp
			}
		}
		return poleImage;

	};

	const getPixelPositionOffset = (offsetWidth, offsetHeight, labelAnchor) => {
		return {
			x: offsetWidth + labelAnchor.x,
			y: offsetHeight + labelAnchor.y,
		};
	};
	 
/* MyComponentToPrint.css */
//const css =`.print-container {width: ${dimensions['width']};  height: ${dimensions['height']};  border: 1px solid black; }`
  
 
	return isLoaded ? (
		<div className="dash-map-wrapper" style={{height:dimensions['height'],width:dimensions['width']}}>
		  
        <ReactToPrint
	
          trigger={() => <div align="end">
				 <Button
					variant="contained"
					className="login-btn"
					style={{ textTransform: "none", }}
				
					>Print</Button>
			</div>
			}
          content={() => componentRef.current}
        />
			
			<div ref={componentRef }  
			style={{ height: dimensions['height'], width: dimensions['width'] }}
			 >
				<div>

					<p style={{ textDecoration: 'underline', textAlign: 'center', fontSize: 24, fontWeight: 'bold' }}>
						{getCityName()} CITY MUNICIPAL CORPORATION
					</p><p style={{ textDecoration: 'underline', textAlign: 'center', fontSize: 18, fontWeight: 'bold' }}>
						ZONE- {zoneNo}, WARD NO- {wardNo}, SWITCH NO -{switchNo}

					</p><p style={{ textDecoration: 'underline', textAlign: 'center', fontSize: 18, fontWeight: 'bold' }}>
						{address} – GIS DATA: {`${location}`} 

					</p><p style={{ textDecoration: 'underline', textAlign: 'center', fontSize: 18, fontWeight: 'bold' }}>
						{phase}-PHASE, SLC UID: {slcUid}
					</p>
				</div>
				<Grid container>
					<Grid xs={12} sm={1}></Grid>
					<Grid xs={12} sm={10}>
						<GoogleMap
							ref={mapRef}
							mapContainerStyle={containerStyle}
							defaultZoom={10}
							onLoad={onLoad}
							options={{
								disableDefaultUI: false,
								styles: [
									{
										featureType: 'poi',
										elementType: 'labels',
										stylers: [{ visibility: 'off' }]
									}
								]
							}}


							//	onCenterChanged={handleCenterChanged}
							yesIWantToUseGoogleMapApiInternals
						>
							{/* poliline */}
							{slcLine.data?.path?.map((arrItem, i) => {
								return (<Polyline

									path={arrItem}
									options={{
										strokeColor: '#000000',
										strokeOpacity: 1.0,
										strokeWeight: 2.5,
									}}
								/>);
							})
							}



							{/* poles */}
							{activePoles.map((pole, i) => {
								const {
									uid: uid = "",
									pnum: pnum = 0,
									nfix: nfix = 0,
									loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
								} = pole;
								var poleNum = pnum;
								var latitude = latitudeVal;
								var longitude = longitudeVal;


								if ((latitude === undefined | "" | 0) || (longitude === undefined | "" | 0)) {
									return (null);
								}

								// var m_pos = poleMarkerPosition[uid];
								var m_pos = poleMarkerPosition.current[uid];

								if (m_pos != undefined) {
									latitude = m_pos.lat;
									longitude = m_pos.lng;
								}
								const position = {
									lat: latitude,
									lng: longitude,
								};
								//console.log(`${i}`+pole['uid'])
								if(uid === null && uid === undefined){
 									return;
								}
								const lamps = LampDataService.getLampsWattsByPid(uid).deviceList; //get lapm watts 
							 
								var wattsObj = {};
								for(var lamp of lamps){
										var wattCount = wattsObj[lamp] ?? 0;
										wattCount = wattCount + 1;
										wattsObj[lamp] = wattCount;
									
								}
								var wattsStr = "";
								
								for (const key in wattsObj) {
									
										var seprator = ",";
										if (wattsStr == "") {
											seprator = "";
										}
										wattsStr = `${wattsStr}${seprator}${key}x${wattsObj[key]}`;
									
								}
								var label = `${poleNum}`
								if(wattsStr != ""){
									var label = `${poleNum}/${wattsStr}`;
								}
								// console.log(`===> Lamp ${uid}, [${latitude},${longitude}]`);
								return (
									<Marker
										key={uid}
										position={position}
										draggable={moveLampFlag.current}
										onDragEnd={(event) => {
											poleMarkerPosition.current[uid] = {
												lat: event.latLng.lat(),
												lng: event.latLng.lng(),
											};

										}}
										// label={label}
										icon={{
											// url: redBulbImg,
											url: getPoleImage(pole),
											scaledSize: new window.google.maps.Size(30, 30),
										}}
										onClick={() => { }}>

										<OverlayView
											key='mwl'
											position={position}
											mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
											// getPixelPositionOffset={(x, y) => getPixelPositionOffset(x, y, { x: 20, y: -40 })}
											>
											<div style={{
											background: `#203254`,
											padding: `3px 8px 3px 3px`,
											fontSize: '12px',
											color: `white`,
											borderRadius: '4px',
										}}>
								<text
										style={{
											background: `#203254`,
											padding: `3px 3px 3px 3px`,
											fontSize: '12px',
											color: `white`,
											borderRadius: '4px',
											
										}}
									>
										 {label}
									</text>
								</div>
										</OverlayView>

									</Marker>
								);
							})}

						</GoogleMap>
					</Grid>

					<Grid item xs={12} sm={1} ></Grid></Grid>


				<Grid container>
					<Grid item xs={12} sm={1} ></Grid>
					<Grid item xs={12} sm={10} >
						 
						<div style={{ paddingTop: '25px', paddingBottom: '25px' }}>
							<table border="1" cellPadding="10" alignItems="center" width="100%" style={{borderCollapse: "collapse"}}>
      <thead>
        <tr>
         {
			uniqueLed.map(wt=>(
				<th key={wt}>LED {wt}</th>
			))
		 }
          <th>Total KW</th>
          <th>Dummy poles</th>
          <th>Total poles</th>
        </tr>
      </thead>
      <tbody >
        <tr>
		{uniqueLed.map(wt => (
              <td key={wt}>{uniqueLedCount[wt]}</td>
            ))}
          <td>{kiloWatts}</td>
          <td>{dummyPoles}</td>
		  <td>{activePoles.length}</td>
        </tr>
      </tbody>
    </table></div>
					</Grid>
					<Grid item xs={12} sm={1}></Grid></Grid>
			</div>
		</div>
	) : (
		<></>
	);
};

export default memo(DashGoogleMap);